<div *ngIf="!!previewData" class="container-fluid sq-preview">
    <div class="row sq-row">
        <div class="col-lg-3 sq-col {{leftPaneAdditionalClasses}}">
            <div class="sq-preview-bar">
                <sq-preview-links class="d-block mb-3"
                    [record]="previewData.record" 
                    [resultId]="previewData.resultId">
                </sq-preview-links>
                <sq-preview-highlights class="d-block mb-3"
                    [previewDocument]="previewDocument"
                    [previewData]="previewData">
                </sq-preview-highlights>
                <sq-facet-card [title]="'msg#preview.documentPropertiesTitle'" class="d-block mb-3">
                    <div class="card-body collapse show" id="documentPropertiesBody">
                        <sq-metadata *ngIf="previewData.record" [record]="previewData.record" [items]="metadata" [showTitles]="false" [showIcons]="true" [clickable]="false">
                        </sq-metadata>
                    </div>
                </sq-facet-card>
                <sq-similar-documents *ngIf="displaySimilarDocuments" class="d-block mb-3"
                    [sourceDocumentId]="previewData.record.id" [query]="query">
                </sq-similar-documents>
            </div>
        </div>
        <div class="col-lg-9 sq-col d-flex flex-column">
            <sq-preview-document-iframe 
                [sandbox] = "sandbox" 
                [downloadUrl]="downloadUrl" 
                (onPreviewReady)="onPreviewReady($event)">
                <sq-preview-tooltip #tooltip
                    [previewDocument]="previewDocument"
                    [previewData]="previewDocument">
                </sq-preview-tooltip>
            </sq-preview-document-iframe>
        </div>
    </div>
</div>